import { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import { useDispatch, useSelector } from "react-redux"
import { formatDinero } from "./../../../utils/formatDinero"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import { obtenerReporteImagenesShareAction } from "../../../ducks/reportesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { Grid } from "@material-ui/core"
const columns = [
    { id: "1", minWidth: 150, align: "center", label: "Referencia" },
    { id: "2", minWidth: 150, align: "center", label: "Paquete" },
    { id: "3", minWidth: 150, align: "center", label: "Vertical" },
    { id: "4", minWidth: 150, align: "center", label: "Horizontal" },
    { id: "5", minWidth: 150, align: "center", label: "Vertical timer" },
    { id: "6", minWidth: 150, align: "center", label: "Horizontal timer" },
]

const useStyles = makeStyles({
    root: {
        width: "100%",
        marginTop: "15px",
    },
    container: {
        maxHeight: 440,
    },
})

const useConsulta = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerReporteImagenesShareAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const ModalReporte = () => {
    useConsulta()
    const { reporteImagenes } = useSelector(store => store.reportes)
    console.log("🚀 ~ ModalReporte ~ reporteImagenes:", reporteImagenes)
    const rows = reporteImagenes?.lBitImgPaqueteConteo ?? []
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <Paper className={classes.root}>
            <Grid container style={{padding: "12px"}}>
                <Grid item xs={3}>
                    <p>Total vertical: {reporteImagenes?.totVertical}</p>
                </Grid>
                <Grid item xs={3}>
                    <p>Total horizontal: {reporteImagenes?.totHorizaontal}</p>
                </Grid>
                <Grid item xs={3}>
                    <p>Total vertical timer: {reporteImagenes?.totVerticalTimer}</p>
                </Grid>
                <Grid item xs={3}>
                    <p>Total horizontal timer: {reporteImagenes?.totHorizaontalTimer}</p>
                </Grid>
            </Grid>

            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                        <TableCell align="center">
                                            <ButtonClienteDetalle
                                                referencia={row?.Meta?.Referencia}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.Meta?.Paquete?.Nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.totVertical}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.totHorizaontal}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.totVerticalTimer}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.totHorizaontalTimer}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}
export default ModalReporte
